export default [
  {
    number: -1,
    shortname: "Pre-K",
    longname: "Preschool",
    url: "prek",
    metaTitle: "Preschool Learning Games, Ages 3 - 4",
    metaDescription:
      "Kids LOVE our free online games! Navigate mazes, befriend unicorns, and explore while practicing numbers, letters, and more preschool skills. Play now!",
    metaKeywords: [
      "pre k",
      "preschool",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 0,
    shortname: "K",
    longname: "Kindergarten",
    url: "k",
    metaTitle: "Kindergarten Learning Games, Ages 5 - 6",
    metaDescription:
      "Kids LOVE our free online games! Race cars, meet cuddly penguins, and explore while practicing counting, sight words, and more kindergarten skills. Play now!",
    metaKeywords: [
      "kindergarten",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 1,
    shortname: "1",
    longname: "First Grade",
    url: "1",
    metaTitle: "First Grade Learning Games, Ages 6 - 7",
    metaDescription:
      "Kids LOVE our free online games! Fly dragons, build dream houses, and explore while practicing addition, reading, and more 1st grade skills. Play now!",
    metaKeywords: [
      "first grade",
      "one",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 2,
    shortname: "2",
    longname: "Second Grade",
    url: "2",
    metaTitle: "Second Grade Learning Games, Ages 7 - 8",
    metaDescription:
      "Kids LOVE our free online games! Launch rockets, rescue cute critters, and explore while practicing subtraction, spelling, and more 2nd grade skills. Play now!",
    metaKeywords: [
      "second",
      "two",
      "grade",
      "one",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 3,
    shortname: "3",
    longname: "Third Grade",
    url: "3",
    metaTitle: "Third Grade Learning Games, Ages 8 - 9",
    metaDescription:
      "Kids LOVE our free online games! Go on quests, bake sweet treats, and explore while practicing fractions, parts of speech, and more 3rd grade skills. Play now!",
    metaKeywords: [
      "third",
      "grade",
      "three",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 4,
    shortname: "4",
    longname: "Fourth Grade",
    url: "4",
    metaTitle: "Fourth Grade Learning Games, Ages 9 - 10",
    metaDescription:
      "Kids LOVE our free online games! Hunt for jewels, fly to space, and explore while practicing times tables, verb tenses, and more 4th grade skills. Play now!",
    metaKeywords: [
      "fourth grade",
      "four",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 5,
    shortname: "5",
    longname: "Fifth Grade",
    url: "5",
    metaTitle: "Fifth Grade Learning Games, Ages 10 - 11",
    metaDescription:
      "Kids LOVE our free online games! Travel the globe, make secret codes, and explore while practicing division, typing, and more 5th grade skills. Play now!",
    metaKeywords: [
      "fifth grade",
      "five",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
  {
    number: 6,
    shortname: "6+",
    longname: "Grade 6+",
    url: "6",
    metaTitle: "Sixth Grade and Up Learning Games, Ages 11+",
    metaDescription:
      "Kids LOVE our free online games! Build bridges, conquer competitors, and explore while practicing math and reading skills for 6th grade and up. Play now!",
    metaKeywords: [
      "sixth grade",
      "six",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "spelling",
      "reading",
      "letters",
      "numbers",
      "shapes",
    ],
  },
];
